import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { CampaignUtilModule } from '../module/campaign-util/campaign-util.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SessionModule } from '../session/session.module';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar.component';
import { UiModule } from '../shared/ui/ui.module';
import { AccountSidebarComponent } from './account-sidebar/account-sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { TimezoneModalComponent } from './topbar/timezone-modal.component';
import { AdminTopbarComponent } from './admin-topbar/admin-topbar.component';

@NgModule({
  declarations: [
    SidebarComponent,
    AdminSidebarComponent,
    AdminTopbarComponent,
    AccountSidebarComponent,
    TopbarComponent,
    TimezoneModalComponent
  ],
  entryComponents: [
    TimezoneModalComponent
  ],
  exports: [
    AdminSidebarComponent,
    AccountSidebarComponent,
    SidebarComponent,
    TopbarComponent,
    AdminTopbarComponent,
  ],
  imports: [
    CommonModule,
    CampaignUtilModule,
    RouterModule,
    SessionModule,
    UiModule,
    SharedModule
  ]
})
export class LayoutModule {

}
